
/**
 * Copyright (c) 2018 Microsoft Corporation
 * Modules Registration
 * THIS FILE IS AUTO-GENERATED - MANUAL MODIFICATIONS WILL BE LOST
 */

/**
 * Register all available modules
 */
export const registerAllModules = (requiredModules) => {
    let binding = { modules: {}, dataActions: {} };
    const { log, error }  = console;
    const detailedWebpackError = (msg, errorObject) => { error(msg); error(errorObject); process.env.NODE_ENV !== 'development' && error('Run in dev mode to see full list of errors'); process.exit(50); }
    const handleError = (modPath, errObject) => {
        detailedWebpackError('Error with path: ' + modPath, errObject);
    }
    if (requiredModules) {
        requiredModules = requiredModules.map((module) => module.toLowerCase());
    }
    const isNotRegistered = (moduleName) => {
        return !requiredModules || requiredModules.length <= 0 || requiredModules.findIndex((module) => module === moduleName) !== -1;
    };

    
    const registerActionId = (actionPath) => {
        if (binding.dataActions[actionPath] &&
            binding.dataActions[actionPath].default &&
            binding.dataActions[actionPath].default.prototype &&
            binding.dataActions[actionPath].default.prototype.id) {
            binding.dataActions[binding.dataActions[actionPath].default.prototype.id] = binding.dataActions[actionPath];
        } else {
            Object.keys(binding.dataActions[actionPath] || {}).forEach(exportName => {
                if (binding.dataActions[actionPath][exportName] &&
                    binding.dataActions[actionPath][exportName].prototype &&
                    binding.dataActions[actionPath][exportName].prototype.Action) {
                    binding.dataActions[binding.dataActions[actionPath][exportName].prototype.id] = binding.dataActions[actionPath][exportName];
                }
            })
        }
    };

    const registerSanitizedActionPath = (sanitizedActionPath, dataAction) => {
        if (process.env.NODE_ENV === 'development') {
            if (!dataAction.default) {
                throw new Error('Data action path does not have a default export');
            }
            if (!(dataAction.default.prototype.id && binding.dataActions[dataAction.default.prototype.id]) || !binding.dataActions[sanitizedActionPath]) {
                binding.dataActions[sanitizedActionPath] = dataAction;
            }
        } else {
            binding.dataActions[sanitizedActionPath] = dataAction;
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
    };
    
    try {


    isNotRegistered('cip-back-top-footer') && (binding.modules['cip-back-top-footer'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-cip-back-top-footer' */
            'partner/modules/cip-back-top-footer/cip-back-top-footer.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'cip-back-top-footer',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/cip-back-top-footer'
    });
        

    isNotRegistered('cip-cta-link') && (binding.modules['cip-cta-link'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-cip-cta-link' */
            'partner/modules/cip-cta-link/cip-cta-link.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'cip-cta-link',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/cip-cta-link'
    });
        

    isNotRegistered('document-search') && (binding.modules['document-search'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-document-search' */
            'partner/modules/document-search/document-search.tsx'),
        $type: 'contentModule',
        da: [{name:'localizationState',  path:'states/localization-state', runOn: 1}],
        
        iNM: false,
        ns: '__local__',
        n: 'document-search',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/document-search'
    });
        

    isNotRegistered('lxs-billing-documents') && (binding.modules['lxs-billing-documents'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-lxs-billing-documents' */
            'partner/modules/lxs-billing-documents/lxs-billing-documents.tsx'),
        $type: 'contentModule',
        da: [{name:'getBillingDocuments',  path:'actions/get-billing-documents.action', runOn: 0},{name:'localizationState',  path:'states/localization-state', runOn: 1}],
        
        iNM: false,
        ns: '__local__',
        n: 'lxs-billing-documents',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/lxs-billing-documents'
    });
        

    isNotRegistered('lxs-contact') && (binding.modules['lxs-contact'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-lxs-contact' */
            'partner/modules/lxs-contact/lxs-contact.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'lxs-contact',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/lxs-contact'
    });
        

    isNotRegistered('lxs-contact-page') && (binding.modules['lxs-contact-page'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-lxs-contact-page' */
            'partner/modules/lxs-contact-page/lxs-contact-page.tsx'),
        $type: 'contentModule',
        da: [{name:'getServiceContacts',  path:'actions/contacts/get-service-contacts.action', runOn: 1}],
        
        iNM: false,
        ns: '__local__',
        n: 'lxs-contact-page',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/lxs-contact-page'
    });
        

    isNotRegistered('lxs-create-order') && (binding.modules['lxs-create-order'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-lxs-create-order' */
            'partner/modules/lxs-create-order/lxs-create-order.tsx'),
        $type: 'contentModule',
        da: [{name:'getCart',  path:'actions/create-order/get-cart.action', runOn: 0},{name:'getFavoriteProducts',  path:'actions/create-order/get-favorite-products.action', runOn: 1},{name:'localizationState',  path:'states/localization-state', runOn: 1},{name:'userRoleState',  path:'states/user-role-state', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'lxs-create-order',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/lxs-create-order'
    });
        

    isNotRegistered('lxs-register') && (binding.modules['lxs-register'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-lxs-register' */
            'partner/modules/lxs-register/lxs-register.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'lxs-register',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/lxs-register'
    });
        

    isNotRegistered('lxs-service-agent') && (binding.modules['lxs-service-agent'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-lxs-service-agent' */
            'partner/modules/lxs-service-agent/lxs-service-agent.tsx'),
        $type: 'contentModule',
        da: [{name:'getDirectLineToken',  path:'actions/get-direct-line-token.action', runOn: 0},{name:'userRoleState',  path:'states/user-role-state', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'lxs-service-agent',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/lxs-service-agent'
    });
        

    isNotRegistered('lxs-user-role') && (binding.modules['lxs-user-role'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-lxs-user-role' */
            'partner/modules/lxs-user-role/lxs-user-role.tsx'),
        $type: 'htmlHeadTagsModule',
        da: [{name:'getUserRole',  path:'actions/user-roles/get-user-roles.action', runOn: 1}],
        
        iNM: false,
        ns: '__local__',
        n: 'lxs-user-role',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/lxs-user-role'
    });
        

    isNotRegistered('lxs-whats-new') && (binding.modules['lxs-whats-new'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-lxs-whats-new' */
            'partner/modules/lxs-whats-new/lxs-whats-new.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'lxs-whats-new',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/lxs-whats-new'
    });
        

    isNotRegistered('master') && (binding.modules['master'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-master' */
            'partner/themes/master/master.tsx'),
        $type: 'themeModule',
        da: [{name:'localizationState',  path:'states/localization-state', moduleName: 'account-profile',runOn: 1},{name:'userRoleState',  path:'states/user-role-state', moduleName: 'promo-banner',runOn: 0}],
        definitionExtensions: ['account-profile','content-block','header','image-list','navigation-menu','promo-banner','site-picker','text-block'],
        iNM: false,
        ns: '__local__',
        n: 'master',
        p: '__local__',
        
        pdp: '',
        
        themeSettings: 'master.theme.settings.json',
        md: 'src/themes/master'
    });
        

    isNotRegistered('order-details') && (binding.modules['order-details'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-order-details' */
            'partner/modules/order-details/order-details.tsx'),
        $type: 'contentModule',
        da: [{name:'getOrderDetails',  path:'actions/order-details/get-order-details.action', runOn: 1},{name:'localizationState',  path:'states/localization-state', runOn: 1}],
        
        iNM: false,
        ns: '__local__',
        n: 'order-details',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/order-details'
    });
        

    isNotRegistered('order-history') && (binding.modules['order-history'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-order-history' */
            'partner/modules/order-history/order-history.tsx'),
        $type: 'contentModule',
        da: [{name:'getExcelConfig',  path:'actions/order-history/get-excel-config.action', runOn: 0},{name:'getOrderHistory',  path:'actions/order-history/get-order-history.action', runOn: 0},{name:'localizationState',  path:'states/localization-state', runOn: 1}],
        
        iNM: false,
        ns: '__local__',
        n: 'order-history',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/order-history'
    });
        

        {   
            const actionPath = 'actions/contacts/get-service-contacts.action';
            binding.dataActions[actionPath] = require('partner/actions/contacts/get-service-contacts.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/create-order/get-all-products.action';
            binding.dataActions[actionPath] = require('partner/actions/create-order/get-all-products.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/create-order/get-cart-order-number.action';
            binding.dataActions[actionPath] = require('partner/actions/create-order/get-cart-order-number.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/create-order/get-cart.action';
            binding.dataActions[actionPath] = require('partner/actions/create-order/get-cart.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/create-order/get-favorite-products.action';
            binding.dataActions[actionPath] = require('partner/actions/create-order/get-favorite-products.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/create-order/get-price-info.action';
            binding.dataActions[actionPath] = require('partner/actions/create-order/get-price-info.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/create-order/get-ship-tos.action';
            binding.dataActions[actionPath] = require('partner/actions/create-order/get-ship-tos.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/create-order/get-sold-to-ids.action';
            binding.dataActions[actionPath] = require('partner/actions/create-order/get-sold-to-ids.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/create-order/get-sold-tos.action';
            binding.dataActions[actionPath] = require('partner/actions/create-order/get-sold-tos.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/create-order/post-cart.action';
            binding.dataActions[actionPath] = require('partner/actions/create-order/post-cart.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/create-order/post-create-order.action';
            binding.dataActions[actionPath] = require('partner/actions/create-order/post-create-order.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/create-order/set-favorite-products.action';
            binding.dataActions[actionPath] = require('partner/actions/create-order/set-favorite-products.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-billing-documents.action';
            binding.dataActions[actionPath] = require('partner/actions/get-billing-documents.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-direct-line-token.action';
            binding.dataActions[actionPath] = require('partner/actions/get-direct-line-token.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-search-orders-and-documents.action';
            binding.dataActions[actionPath] = require('partner/actions/get-search-orders-and-documents.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/order-details/get-document-download.action';
            binding.dataActions[actionPath] = require('partner/actions/order-details/get-document-download.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/order-details/get-order-details.action';
            binding.dataActions[actionPath] = require('partner/actions/order-details/get-order-details.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/order-details/get-tds-document-download.action';
            binding.dataActions[actionPath] = require('partner/actions/order-details/get-tds-document-download.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/order-details/get-tds-document.action';
            binding.dataActions[actionPath] = require('partner/actions/order-details/get-tds-document.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/order-history/get-excel-config.action';
            binding.dataActions[actionPath] = require('partner/actions/order-history/get-excel-config.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/order-history/get-order-history.action';
            binding.dataActions[actionPath] = require('partner/actions/order-history/get-order-history.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/order-history/post-excel-config.action';
            binding.dataActions[actionPath] = require('partner/actions/order-history/post-excel-config.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/user-preferences/get-localization.action';
            binding.dataActions[actionPath] = require('partner/actions/user-preferences/get-localization.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/user-preferences/post-localization.action';
            binding.dataActions[actionPath] = require('partner/actions/user-preferences/post-localization.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/user-roles/get-user-roles.action';
            binding.dataActions[actionPath] = require('partner/actions/user-roles/get-user-roles.action');
            registerActionId(actionPath);
        }

        if (isNotRegistered('document-search')){
            const sanitizedActionPath = 'states/localization-state';
            let dataAction = require('partner/states/localization-state');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lxs-billing-documents')){
            const sanitizedActionPath = 'actions/get-billing-documents.action';
            let dataAction = require('partner/actions/get-billing-documents.action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lxs-billing-documents')){
            const sanitizedActionPath = 'states/localization-state';
            let dataAction = require('partner/states/localization-state');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lxs-contact-page')){
            const sanitizedActionPath = 'actions/contacts/get-service-contacts.action';
            let dataAction = require('partner/actions/contacts/get-service-contacts.action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lxs-create-order')){
            const sanitizedActionPath = 'actions/create-order/get-cart.action';
            let dataAction = require('partner/actions/create-order/get-cart.action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lxs-create-order')){
            const sanitizedActionPath = 'actions/create-order/get-favorite-products.action';
            let dataAction = require('partner/actions/create-order/get-favorite-products.action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lxs-create-order')){
            const sanitizedActionPath = 'states/localization-state';
            let dataAction = require('partner/states/localization-state');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lxs-create-order')){
            const sanitizedActionPath = 'states/user-role-state';
            let dataAction = require('partner/states/user-role-state');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lxs-service-agent')){
            const sanitizedActionPath = 'actions/get-direct-line-token.action';
            let dataAction = require('partner/actions/get-direct-line-token.action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lxs-service-agent')){
            const sanitizedActionPath = 'states/user-role-state';
            let dataAction = require('partner/states/user-role-state');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lxs-user-role')){
            const sanitizedActionPath = 'actions/user-roles/get-user-roles.action';
            let dataAction = require('partner/actions/user-roles/get-user-roles.action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('master')){
            const sanitizedActionPath = 'states/localization-state';
            let dataAction = require('partner/states/localization-state');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('master')){
            const sanitizedActionPath = 'states/user-role-state';
            let dataAction = require('partner/states/user-role-state');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('order-details')){
            const sanitizedActionPath = 'actions/order-details/get-order-details.action';
            let dataAction = require('partner/actions/order-details/get-order-details.action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('order-details')){
            const sanitizedActionPath = 'states/localization-state';
            let dataAction = require('partner/states/localization-state');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('order-history')){
            const sanitizedActionPath = 'actions/order-history/get-excel-config.action';
            let dataAction = require('partner/actions/order-history/get-excel-config.action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('order-history')){
            const sanitizedActionPath = 'actions/order-history/get-order-history.action';
            let dataAction = require('partner/actions/order-history/get-order-history.action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('order-history')){
            const sanitizedActionPath = 'states/localization-state';
            let dataAction = require('partner/states/localization-state');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

    
    } catch (e) {
        handleError('-', e);
    }
    
    return binding;
};